// SubDetails is an admin-only Sub Profile component, so it will live in admin-app.

import { ProfileChips, Section } from "swing-components";

import { SwingHeroImageWrapper } from "~components/Organisms";
import { translate } from "~utils";

type SubDetailsProps = {
  name: string;
  photo?: string;
  daysWorked?: number;
  districtDaysWorked?: number;
  timesPreferred?: number;
  positiveReviews?: number;
  isDistrictFavorited?: boolean;
  hasSpedExperience?: boolean;
  languages: string[];
  isSwingHero?: boolean;
  isReferenceVerified: boolean;
};

export function SubDetails(props: SubDetailsProps) {
  const {
    name,
    photo,
    daysWorked,
    districtDaysWorked,
    timesPreferred,
    positiveReviews,
    isDistrictFavorited,
    languages,
    hasSpedExperience,
    isSwingHero,
    isReferenceVerified,
  } = props;

  return (
    <Section>
      <div css={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h1 css={{ margin: "0 0 var(--spacing-lg) 0", textAlign: "center" }}>{name}</h1>
        {isSwingHero ? (
          <SwingHeroImageWrapper>
            <img
              src={photo}
              css={{
                width: 150,
                height: 150,
                objectFit: "contain",
                borderRadius: "50%",
              }}
            />
          </SwingHeroImageWrapper>
        ) : (
          <img
            src={photo}
            css={{
              width: 150,
              height: 150,
              objectFit: "contain",
              borderRadius: "50%",
            }}
          />
        )}
        <div
          css={{
            display: "flex",
            gap: "var(--spacing-lg)",
            width: "100%",
            marginTop: "var(--spacing-lg)",
          }}
        >
          {daysWorked && daysWorked > 0 ? (
            <Stat stat={daysWorked} description={translate("SUB_PROFILE_DAYS_WORKED_LABEL")}></Stat>
          ) : (
            <></>
          )}
          {districtDaysWorked && districtDaysWorked > 0 ? (
            <Stat
              stat={districtDaysWorked}
              description={translate("SUB_PROFILE_DISTRICT_DAYS_LABEL")}
            ></Stat>
          ) : (
            <></>
          )}
          {timesPreferred && timesPreferred > 0 ? (
            <Stat
              stat={timesPreferred}
              description={translate("SUB_PROFILE_TIMES_PREFERRED_LABEL")}
            ></Stat>
          ) : (
            <></>
          )}
          {positiveReviews && positiveReviews > 0 ? (
            <Stat
              stat={positiveReviews}
              description={translate("SUB_PROFILE_POSITIVE_REVIEWS_LABEL")}
            ></Stat>
          ) : (
            <></>
          )}
        </div>
        <ProfileChips
          chipData={{
            hasSpedExperience,
            isDistrictFavorited,
            languages,
            daysWorked,
            isReferenceVerified,
          }}
        ></ProfileChips>
      </div>
    </Section>
  );
}

type StatProps = {
  stat: number;
  description: string;
};

function Stat(props: StatProps) {
  const { stat, description } = props;
  return (
    <div
      css={{
        borderRadius: 8,
        background: "var(--swing-white300)",
        padding: "var(--spacing-sm)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flex: 1,
      }}
    >
      <div css={{ fontSize: 20, fontWeight: "bold" }}>{stat}</div>
      <div css={{ fontSize: 12, textAlign: "center" }}>{description}</div>
    </div>
  );
}
